export default function OrgColectivElevi() {
const files = [
  "Decizia Comisia inscriere elevi.PDF",
  "Decizia Comisia muncii educative_diriginti.PDF",
  "Decizie Comisie inscriere formatiuni de studii.PDF",
  "PO constituire formatiune de studii_cls 5.PDF",
  "PO constituire formatiune de studii_cls 9.PDF",
  "PO constituire formatiune de studii_pregatitoare.PDF",
  "PO constituire formatiune de studii_gradinita.PDF",
  "PO constituire_clasa pregatitoare.PDF",
  "Raport formatiuni de studii.PDF",
  "Raport inscriere cls IX.PDF",
  "Raport inscriere cls pregatitoare.PDF",
  "Raport inscrieri cls V.PDF",
];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/educatie/orgColectivElevi/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}